import script from "./UserInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserInfo.vue?vue&type=script&setup=true&lang=ts"

import "./UserInfo.vue?vue&type=style&index=0&id=0065bd3b&lang=scss"

const __exports__ = script;

export default __exports__